export default {
    'sort-by-most-visited': 'ترتيب حسب الأكثر زيارة',
    'sort-by-least-visits': 'ترتيب حسب الأقل زيارة'
}